import React, { Component } from "react";
import ReactPaginate from "react-paginate";
import { Table, Card, Row, Col, Image } from "react-bootstrap";
import ExpiryReturnsView from "./ExpiryReturnsView";
var dateFormat = require("dateformat");

class ExpiryReturns extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ExpiryReturnsShow: false,
      page: 0,
      perPage: 10,
      Spage: 0,
      perPageS: 10,
      searchExpiryReturns: "",
      searchShow: false,
      perPagef: 10,
      FltrPage: 0,
      filterValue: "",
      FilterTable: false,
    };
  }

  componentDidMount() {
    this.props.ExpiryReturn();
  }

  handleExpiryReturnsView = (item) => {
    this.setState({
      ExpiryReturnsShow: true,
      ExpiryReturnsDtls: item,
    });
    this.props.ExpiryReturnView(item);
  };

  handleCloseExpiryReturnsView = () => {
    this.setState({ ExpiryReturnsShow: false });
  };

  handlePageClick = (e) => {
    const selectedPage = e.selected;
    this.props.ExpiryReturnsSelectedPage(selectedPage + 1);
    this.setState({ page: selectedPage });
  };

  handlePageSearchClick = (e) => {
    const selectedSearchPage = e.selected;
    this.setState({ Spage: selectedSearchPage });

    this.props.ExpiryReturnsSearchSelectedPage({
      Spage: selectedSearchPage + 1,
      ExpiryReturns: this.state.searchExpiryReturns,
      value: this.state.filterValue,
    });
  };

  SearchOnChange = (event) => {
    const ExpiryReturns = event.target.value;
    const hasSearch = ExpiryReturns !== "";
    const hasFilter = this.state.filterValue !== "";

    this.setState({
      searchShow: hasSearch,
      FilterTable: !hasSearch && hasFilter,
      page: 0,
      FltrPage: 0,
      Spage: 0,
      searchExpiryReturns: ExpiryReturns,
    });

    if (hasSearch) {
      this.props.ExpiryReturnsSearch({
        Spage: 1,
        ExpiryReturns,
        value: this.state.filterValue,
      });
    } else if (hasFilter) {
      this.props.FilterSearchExpiryUser({
        page: 1,
        value: this.state.filterValue,
      });
    } else {
      this.props.ExpiryReturn();
    }
  };

  handleChange = (event) => {
    const filterValue = event.target.value;
    this.setState({
      FltrPage: 0,
      page: 0,
      Spage: 0,
      filterValue,
    });

    if (this.state.searchExpiryReturns) {
      this.setState({
        searchShow: true,
        FilterTable: false,
      });
      this.props.ExpiryReturnsSearch({
        Spage: 1,
        ExpiryReturns: this.state.searchExpiryReturns,
        value: filterValue,
      });
    } else if (filterValue === "") {
      this.setState({
        FilterTable: false,
        searchShow: false,
      });
      this.props.ExpiryReturn();
    } else {
      this.props.FilterSearchExpiryUser({
        page: 1,
        value: filterValue,
      });
      this.setState({ FilterTable: true });
    }
  };

  handlePageFltrClick = (e) => {
    const selectedFltrPage = e.selected;
    this.setState({ FltrPage: selectedFltrPage });

    this.props.fltrExpiryUserPagetn({
      page: selectedFltrPage + 1,
      value: this.state.filterValue,
    });
  };

  render() {
    const p = this.state.page + 1;
    const count = this.props.ExpiryReturnlsCount;
    const pageCount = Math.ceil(count / this.state.perPage);

    const p2 = this.state.Spage + 1;
    const searchCount = this.props.ExpiryReturnSearchCount;
    const searchPageCount = Math.ceil(searchCount / this.state.perPageS);

    const p3 = this.state.FltrPage + 1;
    const fltrCount = this.props.expiryUserFilterCount;
    const fltrPageCount = Math.ceil(fltrCount / this.state.perPagef);
    const defaultList = this.props.ExpiryReturnDtlsList;
    const searchList = this.props.ExpiryReturnSearchList;
    const filterList = this.props.expiryUserFilterList;
    const activeCount = this.state.FilterTable
      ? fltrCount
      : this.state.searchShow
      ? searchCount
      : count;
    const activeList = this.state.FilterTable
      ? filterList
      : this.state.searchShow
      ? searchList
      : defaultList;

    return (
      <div>
        <Card>
          <Card.Header>
            <Row className="align-items-center w-100 justify-content-between tableHeaderRow">
              <Col md={3}>
                <h3>Expiry Returns</h3>
              </Col>

              <Col md={3}>
                <select
                  value={this.state.filterValue}
                  onChange={this.handleChange}
                  className="commonFilterSelect"
                >
                  <option value="">All</option>
                  <option value="created">Created</option>
                  <option value="accepted">Accepted</option>
                  <option value="cancelled">Cancelled</option>
                </select>
              </Col>

              <Col md={3}>
                <div className="commonInput">
                  <i className="fa fa-search fa-lg cmnSearchIcon"></i>
                  <input
                    type="text"
                    placeholder="Search by Order Id/Name"
                    value={this.state.searchExpiryReturns}
                    onChange={this.SearchOnChange}
                  />
                </div>
              </Col>

              <Col md={3}>
                <div className="commonRecrd">
                  <i className="cui-note icons cmnRecordIcon"></i>
                  <span className="cmnPageCount">
                    {activeCount ? activeCount : ""}
                  </span>
                  <span className="cmnResutText">Results</span>
                </div>
              </Col>
            </Row>
          </Card.Header>

          <Card.Body>
            <Table responsive bordered striped className="cmnMainTable">
              <thead>
                <tr className="cmnMainTableHd">
                  <th>SL NO</th>
                  <th>ORDER ID</th>
                  <th>CHEMIST NAME</th>
                  <th>DISTRIBUTOR NAME</th>
                  <th>CREATED DATE</th>
                  <th>STATUS</th>
                  <th>ACTION</th>
                </tr>
              </thead>
              <tbody>
                {activeList &&
                  activeList.map((item, i) => (
                    <tr key={i}>
                      <td>
                        {10 *
                          ((this.state.FilterTable
                            ? p3
                            : this.state.searchShow
                            ? p2
                            : p) -
                            1) +
                          i +
                          1}
                      </td>
                      <td>{item.orderNo}</td>
                      <td>{item.chmstDtls?.name}</td>
                      <td>{item.dstbtrDtls?.name}</td>
                      <td>
                        {item.createdAt &&
                          dateFormat(item.createdAt, "dd-mmm-yyyy")}
                      </td>
                      <td>{item.status}</td>
                      <td className="cmnViewIcon">
                        <i
                          className="fa fa-eye fa-lg"
                          onClick={() => this.handleExpiryReturnsView({ item })}
                        ></i>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>

            {!this.state.searchShow &&
              !this.state.FilterTable &&
              (defaultList === undefined ||
                (defaultList && defaultList.length === 0)) && (
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require("../../assets/img/nodata4.png")}
                    />
                  </div>
                  <div className="noDataTextDiv">No Returns Found</div>
                </div>
              )}

            {this.state.searchShow &&
              !this.state.FilterTable &&
              (searchList === undefined ||
                (searchList && searchList.length === 0)) && (
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require("../../assets/img/nodata4.png")}
                    />
                  </div>
                  <div className="noDataTextDiv">No Returns Found</div>
                </div>
              )}

            {this.state.FilterTable &&
              (filterList === undefined ||
                (filterList && filterList.length === 0)) && (
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require("../../assets/img/nodata4.png")}
                    />
                  </div>
                  <div className="noDataTextDiv">No Returns Found</div>
                </div>
              )}

            <ExpiryReturnsView
              show={this.state.ExpiryReturnsShow}
              handleClose={this.handleCloseExpiryReturnsView}
              ProductReturnsDtls={this.state.ExpiryReturnsDtls}
              ProductReturnls={this.props.ExpiryReturnls}
              ProductReturnDtlsCount={this.props.ExpiryReturnDtlsCount}
            />
          </Card.Body>

          {!this.state.searchShow &&
            !this.state.FilterTable &&
            pageCount > 1 && (
              <div className="paginationDiv">
                <ReactPaginate
                  forcePage={this.state.page}
                  previousLabel={"Prev"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={pageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={this.handlePageClick}
                  containerClassName={"pagination flex-wrap"}
                  subContainerClassName={"pages pagination"}
                  activeClassName={"active"}
                />
              </div>
            )}

          {this.state.searchShow &&
            !this.state.FilterTable &&
            searchPageCount &&
            searchPageCount > 1 && (
              <div className="paginationDiv">
                <ReactPaginate
                  forcePage={this.state.Spage}
                  previousLabel={"Prev"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={searchPageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={this.handlePageSearchClick}
                  containerClassName={"pagination flex-wrap"}
                  subContainerClassName={"pages pagination"}
                  activeClassName={"active"}
                />
              </div>
            )}

          {this.state.FilterTable && fltrPageCount > 1 && (
            <div className="paginationDiv">
              <ReactPaginate
                forcePage={this.state.FltrPage}
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                pageCount={fltrPageCount}
                onPageChange={this.handlePageFltrClick}
                containerClassName={"pagination flex-wrap"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          )}
        </Card>
      </div>
    );
  }
}

export default ExpiryReturns;
